import { useGetCountryCodeOptions } from 'hooks/useGetCountryCodeOptions';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Box, Grid, TextField, Typography } from '@mui/material';

import { Select } from 'components/shared';

type Props = {
  formKey: string;
};

const AddressForm = ({ formKey }: Props) => {
  const { t } = useTranslation();
  const { control } = useFormContext();
  const options = useGetCountryCodeOptions();

  return (
    <Box mt={3}>
      <Typography variant="h3" sx={{ mb: 1 }}>
        {t(`travelDistances.${formKey}`)}
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={8}>
          <Controller
            name={`${formKey}.street`}
            control={control}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                fullWidth
                label={t('street')}
                error={!!fieldState.error}
                helperText={fieldState.error?.message ?? null}
                required
              />
            )}
          />
        </Grid>
        <Grid item xs={4}>
          <Controller
            name={`${formKey}.houseNumber`}
            control={control}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                fullWidth
                label={t('houseNumber')}
                error={!!fieldState.error}
                helperText={fieldState.error?.message ?? null}
                required
              />
            )}
          />
        </Grid>
        <Grid item xs={3}>
          <Controller
            name={`${formKey}.postalCode`}
            control={control}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                fullWidth
                label={t('postalCode')}
                error={!!fieldState.error}
                helperText={fieldState.error?.message ?? null}
                required
              />
            )}
          />
        </Grid>
        <Grid item xs={5}>
          <Controller
            name={`${formKey}.city`}
            control={control}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                fullWidth
                label={t('city')}
                error={!!fieldState.error}
                helperText={fieldState.error?.message ?? null}
                required
              />
            )}
          />
        </Grid>
        <Grid item xs={4}>
          <Controller
            name={`${formKey}.countryCode`}
            control={control}
            render={({ field, fieldState }) => (
              <Select
                fullWidth
                {...field}
                onSelected={field.onChange}
                label={t('country')}
                options={options}
                error={fieldState.error}
                valueProp={field.value}
                required
              />
            )}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default AddressForm;
